type GridTableSkeletonProps = {
  rowCount?: number;
  columnCount?: number;
};

const GridTableSkeleton = ({ rowCount = 10, columnCount = 5 }: GridTableSkeletonProps) => {
  return (
    <div className="border border-gray-200 rounded-lg overflow-hidden bg-white">
      <div className="overflow-auto">
        <table className="w-full">
          <thead className="bg-slate-50 border-b border-gray-200">
            <tr>
              {Array.from({ length: columnCount }).map((_, colIndex) => (
                <th
                  key={`skeleton-header-${colIndex}`}
                  className="px-5 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider h-10"
                >
                  <div className="relative h-4 w-24 overflow-hidden rounded bg-gray-200">
                    <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/70 to-transparent" />
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {Array.from({ length: rowCount }).map((_, rowIndex) => (
              <tr key={`skeleton-row-${rowIndex}`} className="h-11">
                {Array.from({ length: columnCount }).map((_, colIndex) => (
                  <td
                    key={`skeleton-cell-${rowIndex}-${colIndex}`}
                    className="px-5 py-3 font-medium text-gray-700"
                  >
                    <div className="relative h-4 w-full overflow-hidden rounded bg-gray-200">
                      <div className="absolute inset-0 -translate-x-full animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/70 to-transparent" />
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GridTableSkeleton;
